import React from 'react';
import { motion } from 'framer-motion';
import { Upload, Cpu, ClipboardCheck } from 'lucide-react';
export function HowItWorksSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const steps = [{
    icon: <Upload className="w-8 h-8 text-[#FF0000]" data-id="element-2822" />,
    title: 'Upload Evidence',
    description: 'Paste your message or upload a screenshot of the conversation. 100% private and encrypted.',
    step: '01'
  }, {
    icon: <Cpu className="w-8 h-8 text-[#FFD700]" data-id="element-2823" />,
    title: 'AI Forensic Analysis',
    description: 'Our proprietary AI scans the text for manipulation, gaslighting, and emotional abuse patterns.',
    step: '02'
  }, {
    icon: <ClipboardCheck className="w-8 h-8 text-[#FF0000]" data-id="element-2824" />,
    title: 'Get Toxicity Report',
    description: 'Receive a detailed forensic dossier breaking down the hidden tactics used against you.',
    step: '03'
  }];
  return <section className="relative py-24 bg-[#050505] overflow-hidden border-t border-gray-900" data-id="element-2825">
      {/* Grid Background */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-2826" />

      <div className="relative z-10 max-w-6xl mx-auto px-6" data-id="element-2827">
        <div className="text-center mb-16" data-id="element-2828">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-[#FF0000]/10 text-[#FF0000] px-4 py-1.5 rounded-full border border-[#FF0000]/30 mb-6 font-mono text-xs font-bold tracking-widest uppercase" data-id="element-2829">
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF0000] animate-pulse" data-id="element-2830" />
            System Process
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black text-white uppercase tracking-tighter mb-4" data-id="element-2831">
            How It <span className="text-[#FF0000]" data-id="element-2832">Works</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gray-400 font-mono max-w-2xl mx-auto" data-id="element-2833">
            Three steps to uncover the truth hidden in your digital
            conversations.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2834">
          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative bg-[#0A0A0A] border border-gray-800 rounded-xl p-8 group hover:border-[#FF0000]/50 transition-colors duration-300" data-id="element-2835">
              {/* Corner Markers */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-gray-700 group-hover:border-[#FF0000] rounded-tl-lg transition-colors" data-id="element-2836" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-gray-700 group-hover:border-[#FF0000] rounded-tr-lg transition-colors" data-id="element-2837" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-gray-700 group-hover:border-[#FF0000] rounded-bl-lg transition-colors" data-id="element-2838" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-gray-700 group-hover:border-[#FF0000] rounded-br-lg transition-colors" data-id="element-2839" />

              <div className="text-[64px] font-black text-white/5 absolute top-4 right-6 select-none pointer-events-none" data-id="element-2840">
                {step.step}
              </div>

              <div className="w-16 h-16 bg-black border border-gray-800 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-2841">
                {step.icon}
              </div>

              <h3 className="text-xl font-bold text-white uppercase tracking-wide mb-3" data-id="element-2842">
                {step.title}
              </h3>
              <p className="text-gray-400 font-mono text-sm leading-relaxed" data-id="element-2843">
                {step.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}